import { render, staticRenderFns } from "./mingxi.vue?vue&type=template&id=df963d24&scoped=true"
import script from "./mingxi.vue?vue&type=script&lang=js"
export * from "./mingxi.vue?vue&type=script&lang=js"
import style0 from "./mingxi.vue?vue&type=style&index=0&id=df963d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df963d24",
  null
  
)

export default component.exports